import requestStatus from "../constants/requestStatus"


const isLoading = (status, error = false) => {
    let loading = false

    if(
        requestStatus.INITIALIZED === status ||
        requestStatus.REQUEST_PENDING === status 
    ) {
        loading = true
    } else if(requestStatus.REQUEST_ERROR === status) {
        if(error) {
            throw new Error(error)
        }
    }

    return loading
}

export default isLoading